import { CustomField } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "customOptionsFieldTextTab",
  initialState: {} as SliceState<CustomField>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const customFieldTextTabReducer = formSlice.reducer;
export default customFieldTextTabReducer;
